export default __webpack_public_path__ + "static/media/100goat_hed.5f2b600f.png";